import { makeStyles } from '@material-ui/core/styles';
import { SecondaryColors } from '@/utils/constants';

const darkTheme = {
  root: {
    '& $title': {
      color: SecondaryColors.main,
    },
  },
};

const lightTheme = {
  root: {
    '& $title': {
      color: SecondaryColors.dark,
    },
  },
};

const useStyles = makeStyles(
  (muiTheme) => ({
    root: {
      '&.dark-theme': darkTheme.root,
      '&.light-theme': lightTheme.root,
      width: '100%',
    },

    title: {
      '&.MuiTypography-root': {
        marginBottom: '12px',
      },
    },

    columns: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
      margin: muiTheme.spacing(-3),

      '& .column': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        alignContent: 'flex-start',

        '& > *': {
          width: '100%',
        },
      },

      [muiTheme.breakpoints.down('sm')]: {
        flexDirection: 'column',
      },
    },

    column: {
      padding: muiTheme.spacing(3),

      '& p:not(:last-child)': {
        marginBottom: muiTheme.spacing(3),
      },
    },
  }),
  { name: 'GenFourFiveColumnContent' },
);

export default useStyles;
